module.exports = __webpack_public_path__ + "static/media/initiald.fc0cf1f3.png";